import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function ManufacturingMenu() {
  return (
    <section>
      <div className="row">

        {/* Products */}
        <MenuCard link="/manu-dash" icon="fa-solid fa-pie-chart" title="Dasboard" />
        <MenuCard link="/iot-map" icon="fa-solid fa-map" title="IoT Map" />
        <MenuCard link="/control-room" icon="fa-solid fa-bar-chart" title="Control Room" />

        <MenuCard link="/products" icon="fa-solid fa-box" title="Products" />

        {/* BOM */}
        <MenuCard link="/bom" icon="fa-solid fa-sitemap" title="BOM" />

        {/* Work Centers */}
        <MenuCard link="/work-centers" icon="fa-solid fa-gears" title="Work Centers" />

        {/* Machines */}
        <MenuCard link="/machines" icon="fa-solid fa-wrench" title="Machines" />

        {/* Production Orders */}
        <MenuCard link="/production-orders" icon="fa-solid fa-clipboard-list" title="Production Orders" />

        {/* Material Issue */}
        <MenuCard link="/material-issue" icon="fa-solid fa-arrow-right-arrow-left" title="Material Issue" />

        {/* Production Entry */}
        <MenuCard link="/production-entry" icon="fa-solid fa-stream" title="Production Entry" />

        {/* Maintenance */}
        <MenuCard link="/maintenance" icon="fa-solid fa-screwdriver-wrench" title="Maintenance" />

        {/* Preventive Maintenance */}
        <MenuCard link="/preventive-maintenance" icon="fa-solid fa-calendar-check" title="Preventive Maintenance" />

        {/* Breakdown */}
        <MenuCard link="/breakdown" icon="fa-solid fa-triangle-exclamation" title="Breakdown" />

        {/* Spare Parts */}
        <MenuCard link="/spare-part" icon="fa-solid fa-toolbox" title="Spare Parts" />

        <MenuCard link="/rfid-page" icon="fa-solid fa-id-card" title="RFID Tags" />

        <MenuCard link="/branch-page" icon="fa-solid fa-code-branch" title="Branches" />

        <MenuCard link="/iot-device" icon="fa-solid fa-microchip" title="IoT Devices" />

        <MenuCard link="/iot-data" icon="fa-solid fa-chart-line" title="IoT Data" />

        <MenuCard link="/prod-move" icon="fa-solid fa-truck-moving" title="Product Movement" />


      </div>
    </section>
  );
}

function MenuCard({ link, icon, title }) {
  return (
    <div className="col-sm-2 me-4">
      <div className="card shadow mt-4" id="my-card">
        <div className="card-body">
          <a href={link}>
            <FontAwesomeIcon
              icon={icon}
              size="4x"
              className="mx-auto d-block"
              color="#2194d9"
            />
            <p className="fw-bold pt-2 text-center">{title}</p>
          </a>
        </div>
      </div>
    </div>
  );
}

export default ManufacturingMenu;
